<mat-toolbar class="header-toolbar">
  <!-- Hamburger menu (tylko na małych ekranach) -->
  <button
    mat-icon-button
    class="menu-icon"
    (click)="sidenav.toggle()"
    *ngIf="mobileQuery.matches"
  >
    <mat-icon>menu</mat-icon>
  </button>

  <!-- Logo -->
  <a class="logo" routerLink="/home">
    <img src="assets/img/logo.png" alt="Logo" />
  </a>

  <!-- Nawigacja (widoczna tylko na większych ekranach) -->
  <div class="nav-links" *ngIf="!mobileQuery.matches">
    <a mat-button href="https://evently.pl/profile/guarana-impro">Repertuar</a>
    <a mat-button routerLink="/o-nas">O nas</a>
    <a href="https://evently.pl/profile/guarana-impro">
      <button mat-button class="buy-ticket-button custom-button">
        Kup bilet
      </button>
    </a>
  </div>
</mat-toolbar>

<!-- Panel boczny na urządzeniach mobilnych -->
<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #sidenav mode="over" class="mobile-menu">
    <mat-nav-list>
      <a mat-list-item routerLink="/repertuar">Repertuar</a>
      <a mat-list-item routerLink="/o-nas">O nas</a>
      <a mat-list-item routerLink="/kup-bilet" class="buy-ticket-link"
        >Kup bilet</a
      >
    </mat-nav-list>
  </mat-sidenav>
</mat-sidenav-container>
